import { APP_BASE_HREF, CurrencyPipe, DecimalPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withHashLocation,
  withPreloading,
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  ExcelExportService as ExcelExportGridService,
  PdfExportService,
} from '@syncfusion/ej2-angular-grids';
import {
  DayService,
  DragAndDropService,
  ExcelExportService,
  MonthAgendaService,
  MonthService,
  ResizeService,
  TimelineMonthService,
  TimelineViewsService,
  WeekService,
  WorkWeekService,
} from '@syncfusion/ej2-angular-schedule';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { AppRoutes } from './app.routes';
import { DemoTourService } from './services/demo-tour.service';
import { CustomDateAdapter } from './utils/CustomDateAdapter';
import AreaPipe from './utils/pipes/area.pipe';
import DurationPipe from './utils/pipes/duration.pipe';
import DynamicDatePipe from './utils/pipes/dynamic-date.pipe';
import ImperialPipe from './utils/pipes/imperial.pipe';
import OrderByPipe from './utils/pipes/order-by.pipe';
import TemperaturePipe from './utils/pipes/temperature.pipe';
import ValueByKeyPipe from './utils/pipes/value-by-key.pipe';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(
      AppRoutes,
      withComponentInputBinding(),
      withHashLocation(),
      withPreloading(PreloadAllModules)
    ),
    provideAnimations(),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideTranslateService({
      fallbackLang: 'fr',
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(MatNativeDateModule),
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: APP_BASE_HREF, useValue: '/' },
    DayService,
    WeekService,
    WorkWeekService,
    MonthService,
    MonthAgendaService,
    DragAndDropService,
    ResizeService,
    TimelineViewsService,
    TimelineMonthService,
    ExcelExportService,
    PdfExportService,
    ExcelExportGridService,
    CurrencyPipe,
    DurationPipe,
    OrderByPipe,
    ImperialPipe,
    DemoTourService,
    DynamicDatePipe,
    DecimalPipe,
    AreaPipe,
    ValueByKeyPipe,
    TemperaturePipe,
    MatPaginatorIntl,
  ],
};
